import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import {
  PharmacySearchComponent,
  WholesalerPharmacyComponent,
  WholesalerPharmacySelectorComponent,
  WholesalerSearchComponent,
} from './components';
import { ReactiveFormsModule } from '@angular/forms';

const components = [
  WholesalerPharmacyComponent,
  WholesalerPharmacySelectorComponent,
  WholesalerSearchComponent,
  PharmacySearchComponent,
];

@NgModule({
  imports: [CommonModule, I18nModule, IconModule, ReactiveFormsModule],
  declarations: [...components],
  exports: [...components],
})
export class WholesalerPharmacyModule {}
